import { CallbackRequestData, WillCallbackRequestData } from '@/lib/schema';

export async function submitCallbackRequest(data: CallbackRequestData) {
  const response = await fetch('/api/callback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to submit request');
  }

  return response.json();
}

export async function submitWillCallbackRequest(data: WillCallbackRequestData) {
  const response = await fetch('/api/will-callback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to submit request');
  }

  return response.json();
}
